module.exports = __webpack_public_path__ + "img/simplepay.36a53ea.png";